<div class="container">
  <h2 mat-dialog-title class="header">
    <mat-icon>info</mat-icon>
  </h2>

  <mat-dialog-content class="content">
    <p>¿Sigues en Sophia?</p>

    <span>Tu sesión será finalizada por inactividad</span>

    <div class="timer">
      <mat-icon svgIcon="timer"></mat-icon>

      <strong>{{ minutes }}:{{ seconds }}</strong>

      <span>Tiempo restante</span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="actions">
    <button mat-button class="btn-outline" (click)="cerrarSesion()">
      Cerrar sesión
    </button>
    <button mat-button class="btn-primary" (click)="continuarSesion()">
      Seguir conectado
    </button>
  </mat-dialog-actions>
</div>
